import {
  mapToSection,
  type SectionOut,
} from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/SectionOut.ts";
import {
  mapToPosition,
  type PositionOut,
} from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/PositionOut.ts";
import {
  mapToRole,
  type RoleOut,
} from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/RoleOut.ts";
import type { HourlyTagOut } from "@/pages/human-resources/time-management/endpoints/tags/inout/HourlyTagOut.ts";
import {
  type ScheduleTemplateOut,
  templateMapper,
} from "@/pages/human-resources/time-management/endpoints/schedules/templates/inout/ScheduleTemplateOut.ts";
import {
  type DailyTagOut,
  mapToDailyTag,
} from "@/pages/human-resources/time-management/endpoints/tags/inout/DailyTagOut.ts";
import { DomainScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/DomainScheduleReferenceData.ts";
import { HourlyTagCategoryResolver } from "@/pages/human-resources/time-management/business/reference/HourlyTagCategoryResolver.ts";

export interface DomainScheduleReferenceDataOut {
  domainId: string;
  sectionsOut: SectionOut[];
  positionsOut: PositionOut[];
  rolesOut: RoleOut[];
  hourlyTagsOut: HourlyTagOut[];
  templatesOut: ScheduleTemplateOut[];
  dailyTagsOut: DailyTagOut[];
}

export function mapToDomainScheduleReferenceData(
  out: DomainScheduleReferenceDataOut,
): DomainScheduleReferenceData {
  const resolver = new HourlyTagCategoryResolver(out.hourlyTagsOut);
  return new DomainScheduleReferenceData(
    out.domainId,
    out.sectionsOut.filter((dto) => dto.active).map(mapToSection),
    out.positionsOut.map(mapToPosition),
    out.rolesOut.map((r, i) => mapToRole(r, i)),
    out.dailyTagsOut.map(mapToDailyTag),
    out.templatesOut.map(templateMapper(resolver, out.domainId)),
    resolver,
  );
}
